<template>
    <dashboard-layout tit="미팅관리" fullHeight>
        <template slot="contents">
            <template v-if="items.length">
                <div class="applied-cards">
                    <schedule-list-item v-for="item in items" :key="item._id" :value="item" @input="updateItem" />
                </div>
                <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
            </template>
            <template v-else>
                <v-layout column justify-center align-center class="w-100 h-100 grey-f7 rounded-lg pa-20">
                    <p class="page-text--lg line-height-15 text-center mb-12 mb-lg-32">
                        안녕하세요. <br />
                        요청된 미팅이 없습니다.
                    </p>
                    <v-btn href="/recruitments" text height="auto" color="transparent">
                        <span class="grey-9--text">채용공고 지원하기</span>
                    </v-btn>
                </v-layout>
            </template>
        </template>
    </dashboard-layout>
    <!-- <v-layout column justify-center>
        <v-card-text class="d-flex flex-column fill-height pa-lg-60 pa-30" style="overflow: auto">
            <template v-if="items.length">
                <schedule-list-item v-for="item in items" :key="item._id" :value="item" outlined rounded="lg" class="mb-16" @input="updateItem" />
                <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-16" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
            </template>
            <template v-else>
                <v-layout column justify-center align-center fill-height class="text-center text-h4 font-weight-bold" style="line-height: 1.4">
                    안녕하세요. <br />
                    요청된 미팅이 없습니다.
                    <v-btn x-large color="primary" class="my-24" href="/recruitments"> 채용공고 지원하기 </v-btn>
                </v-layout>
            </template>
        </v-card-text>
    </v-layout> -->
</template>

<script>
import api from "@/api";

import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import ScheduleListItem from "@/components/dashboard/person/meeting/list/schedule-list-item.vue";

export default {
    components: {
        DashboardLayout,
        ScheduleListItem,
    },
    data: () => ({
        loading: false,
        meetings: [],

        limit: 10,
        summary: { totalCount: 0 },

        showsSearch: true,
    }),
    computed: {
        items() {
            return this.meetings.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.init();
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            this.loading = true;
            try {
                let { skip, limit, params } = this;
                var { summary, meetings } = await api.v1.person.meetings.gets({
                    headers: { skip, limit },
                    params,
                });

                this.meetings = meetings;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
        updateItem(item) {
            const index = this.meetings.findIndex(({ _id }) => _id == item._id);
            if (0 <= index) this.meetings.splice(index, 1, item);
            else {
                this.meetings = [item, ...this.meetings];
                this.summary.totalCount += 1;
            }
            this.init();
        },
    },
};
</script>

<style></style>
